import { createClient } from '@supabase/supabase-js'
import { log } from '@/lib/log'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validation and helpful error messages
const isProduction = import.meta.env.PROD
const isDevelopment = import.meta.env.DEV

if (!supabaseUrl || supabaseUrl === 'your_supabase_project_url_here') {
  const message = 'VITE_SUPABASE_URL is not set or using placeholder value'
  log.error(message)
  
  if (isProduction) {
    throw new Error(`${message}. This is a critical configuration error in production.`)
  }
  
  if (isDevelopment) {
    log.info('Please update your .env file with your actual Supabase project URL')
    log.info('Find it at: https://app.supabase.com/project/YOUR_PROJECT/settings/api')
  }
}

if (!supabaseAnonKey || supabaseAnonKey === 'your_supabase_anon_key_here') {
  const message = 'VITE_SUPABASE_ANON_KEY is not set or using placeholder value'
  log.error(message)
  
  if (isProduction) {
    throw new Error(`${message}. This is a critical configuration error in production.`)
  }
  
  if (isDevelopment) {
    log.info('Please update your .env file with your actual Supabase anon key')
    log.info('Find it at: https://app.supabase.com/project/YOUR_PROJECT/settings/api')
  }
}

// Create client with fallback values only in development
const fallbackUrl = 'https://placeholder.supabase.co'
const fallbackKey = 'placeholder-key'

export const supabase = createClient(
  supabaseUrl || (isDevelopment ? fallbackUrl : ''), 
  supabaseAnonKey || (isDevelopment ? fallbackKey : ''),
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
    db: {
      schema: 'public',
    },
    global: {
      headers: {
        'x-client-info': 'hellofuture-web@1.0.0',
      },
    },
  }
)

// Test connection function
export async function testSupabaseConnection() {
  try {
    const { data, error } = await supabase.from('profiles').select('count').limit(1);
    if (error) {
      console.error('❌ Supabase connection test failed:', error.message);
      return { success: false, error: error.message };
    }
    console.log('✅ Supabase connection test successful');
    return { success: true, data };
  } catch (err) {
    console.error('❌ Supabase connection test error:', err);
    return { success: false, error: err instanceof Error ? err.message : 'Unknown error' };
  }
}

// Log connection status on module load (development only)
if (isDevelopment) {
  console.log('🔧 Supabase Client Configuration:');
  console.log('   URL:', supabaseUrl || '❌ NOT SET');
  console.log('   Key:', supabaseAnonKey ? '✅ SET' : '❌ NOT SET');
}